import axios from 'axios';
import { toast } from 'react-toastify';

// ⬅ MODIF 1 : fallback en relatif pour le sous-chemin /soplast
const API_URL = process.env.REACT_APP_API_URL || '/soplast/api';

let authEventListeners = [];

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Fonction pour notifier tous les composants de la déconnexion
const notifyAuthChange = (isAuthenticated) => {
    authEventListeners.forEach(callback => callback(isAuthenticated));
};

// Fonction pour s'abonner aux changements d'authentification
export const subscribeToAuthChanges = (callback) => {
    authEventListeners.push(callback);
    return () => {
        authEventListeners = authEventListeners.filter(cb => cb !== callback);
    };
};

// Fonction pour nettoyer les données utilisateur et rediriger
const handleLogout = (showMessage = true) => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');

    // Marquer qu'il faut afficher le message sur la page de login
    if (showMessage) {
        localStorage.setItem('showSessionExpiredMessage', 'true');
    }

    notifyAuthChange(false);

    // ⬅ MODIF 2 : tenir compte du basename /soplast
    const loginPath = `${process.env.PUBLIC_URL}/login`;
    if (window.location.pathname !== loginPath) {
        window.location.replace(loginPath);
    }
};

// Fonction pour vérifier la validité du token
export const checkTokenValidity = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;

    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Date.now() / 1000;

        return payload.exp > currentTime;
    } catch (error) {
        return false;
    }
};

// Intercepteur de requête
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            if (!checkTokenValidity()) {
                handleLogout();
                return Promise.reject(new Error('Token expired'));
            }

            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Intercepteur de réponse
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            // ⬅ MODIF 3 : tenir compte du basename /soplast
            if (window.location.pathname !== `${process.env.PUBLIC_URL}/login`) {
                handleLogout();
            }
        }

        if (error.response && error.response.status === 403) {
            // toast.error('Accès refusé. Vous n\'avez pas les permissions nécessaires.');
        }

        if (!error.response) {
            // toast.error('Erreur de connexion. Vérifiez votre connexion internet.');
        }

        return Promise.reject(error);
    }
);

// Fonction pour vérifier et afficher le message de session expirée
export const checkAndShowSessionExpiredMessage = () => {
    const shouldShowMessage = localStorage.getItem('showSessionExpiredMessage');
    if (shouldShowMessage === 'true') {
        localStorage.removeItem('showSessionExpiredMessage');
        toast.warning('Votre session a expiré. Veuillez vous reconnecter.');
        return true;
    }
    return false;
};

export default api;